import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { Icon, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Divider, Menu, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
export const PropertyActionsMenu = observer(_ref => {
  var _store$homeDashboardS;
  let menuTriggerExternal = _ref.menuTriggerExternal,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    isActive = _ref.isActive,
    id = _ref.id,
    portfolioId = _ref.portfolioId,
    openPropertyDetails = _ref.openPropertyDetails,
    name = _ref.name,
    hideEditPropertyOption = _ref.hideEditPropertyOption,
    selectActionCallback = _ref.selectActionCallback,
    handleRemovePortfolioFromProperty = _ref.handleRemovePortfolioFromProperty,
    isInDefaultPortfolio = _ref.isInDefaultPortfolio,
    handleOpenAssignPortfoliosToPropertyModal = _ref.handleOpenAssignPortfoliosToPropertyModal;
  const classes = useStyles();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDeleteModalOpen = _useState2[0],
    setIsDeleteModalOpen = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  const discardProperty = async () => {
    const resp = await store.properties.deletePropertyAsync.run({
      applyToHomeDashboard: true,
      propertyId: id
    }, [id]);
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully deleted']
      });
      store.homeDashboardStore.getPortfolioByPropertyId(id).deleteProperty(id);
      await store.portfolios.getPortfoliosDashboardAsync.run({
        storeCompany: true
      }, [id]);
    }
  };

  // const goToProcessUtilityBills = async () => {
  //   if (changeActiveProperty) changeActiveProperty();
  // };

  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('Property options'),
    key: 'PropertyActionsMenu' + ((_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.enableShortcutsHintState),
    placement: 'top',
    type: 'info'
    // open={store.homeDashboardStore?.enableShortcutsHintState || undefined}
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    size: "large",
    'custom-attribute': '352-PropertyActionsMenu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "portfolio-action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, isActive && /*#__PURE__*/React.createElement(React.Fragment, null, !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      track(events.modalOpened('Enroll Resident'));
      handleShowEnrollModal(true);
      handleClose();
    },
    'custom-attribute': '353-PropertyActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('portfolios_properties_page.enroll_resident')), !hideEditPropertyOption && (openPropertyDetails ? /*#__PURE__*/React.createElement(Button, {
    id: "editNewProperty",
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      openPropertyDetails(id);
    },
    'custom-attribute': '355-PropertyActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit_property')) : /*#__PURE__*/React.createElement(Button, {
    id: "editNewProperty",
    variant: "menuAction",
    component: RouterLink,
    to: "/edit_property?id=".concat(id),
    'custom-attribute': '356-PropertyActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit_property')))), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleOpenAssignPortfoliosToPropertyModal();
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), t('Add portfolio')), !isInDefaultPortfolio && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleRemovePortfolioFromProperty();
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), t('Remove from portfolio')), !isActive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction"
    // onClick={() => navigate(`/new_property?not_completed_id=${id}`)}
    ,
    onClick: () => {
      store.addNewProperty.resetStoreToInitValues();
      store.vendors.resetStore();
      navigate("/active_dashboard?not_completed_id=".concat(id));
      selectActionCallback({
        entityType: 'portfolio',
        _id: portfolioId,
        prefetchDataOnly: false
      });
      selectActionCallback({
        entityType: 'property',
        _id: id,
        prefetchDataOnly: false
      });
    },
    'custom-attribute': '358-PropertyActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('dashboard_page.continue_adding_details')), !store.company.companyFeatureStore.disableDeleteIncompletedProperty && !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      setIsDeleteModalOpen(true);
    },
    'custom-attribute': '359-PropertyActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), t('dashboard_page.discard_property'))))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: t('dashboard_page.discard_property'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('dashboard_page.delete_the_properties', {
      name
    }))),
    externalIsOpen: isDeleteModalOpen,
    callBack: _ref2 => {
      let action = _ref2.action;
      setIsDeleteModalOpen(false);
      if (action === 'submit') discardProperty();
    },
    customTrigger: null
  }));
});